import theme from '@theme';
import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

import { Icon, IIconName } from '../icon';

interface DisplayFieldNameProps {
  iconName: ReactElement | IIconName['iconName'];
  children: ReactNode;
}

const DisplayFieldName: React.FC<DisplayFieldNameProps> = ({ iconName, children }) => (
  <DisplayFieldNameContainer>
    <IconContainer>
      {React.isValidElement(iconName) ? (
        React.cloneElement(iconName as ReactElement, {
          style: { fill: theme.palette.grey[400] }
        })
      ) : (
        <CustomIcon iconName={iconName as IIconName['iconName']} />
      )}
    </IconContainer>
    <FormatFieldName>{children}</FormatFieldName>
  </DisplayFieldNameContainer>
);

const DisplayFieldNameContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 8.875rem;
  justify-items: start;
  column-gap: 0.375rem;
  width: 10rem;
  padding-right: 0.75rem;
`;

const FormatFieldName = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 500;
  color: ${theme.palette.grey[400]};
  justify-content: center;
  align-items: center;
`;

const IconContainer = styled.div`
  width: 0.75rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CustomIcon = styled(Icon)`
  width: 0.75rem;
  color: ${theme.palette.grey[400]};
`;

export default DisplayFieldName;
